// extracted by css-extract-rspack-plugin
export default {"SidesheetContent":"QqTsB","SidesheetHeader":"v3aB1","SidesheetCloseButton":"pCCqq","FlexScrollContainer":"aJtdu","OverflowAuto":"CPwLu","InsightsTab":"Ppyeq","TabSibling":"N7Vao"};